<ng-container *transloco="let t; prefix: 'group-management.interested-parties'">
  <app-panel-body>
    <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <div class="flex justify-end">
              <app-interested-parties-export-button />
            </div>
            <p class="m-0 text-sm text-primary-text-light">{{ t('description') }}</p>

            @if (loadError()) {
              <app-inline-alert severity="danger" [message]="t('load-error')" />
            } @else if (loading()) {
              <p class="m-0 text-sm text-primary-text-light">{{ t('loading') }}</p>
            } @else if (!hasParties()) {
              <app-empty-state [title]="t('empty-title')" [description]="t('empty-description')" />
            } @else {
              <app-interested-parties-list />
            }
          </div>
        </app-content-container>
      </div>
    </div>
  </app-panel-body>
</ng-container>
